module.exports = __webpack_public_path__ + "static/media/place.4c5c76bc.svg";